import type { GrantDto } from "../../services/UserService";
import CustomerId from "../../state/CustomerId";
import type { Grant } from "../../state/grant";
import ResourceId from "../../state/ResourceId";
import RoleId from "../../state/RoleId";

export const toGrant = (dto: GrantDto): Grant => ({
  customerId: CustomerId.from(dto.customerId.toString()),
  resourceType: dto.resourceType,
  roleId: RoleId.from(dto.roleId),
  resourceId: ResourceId.from(dto.resourceId),
});

export const toGrantDto = (grant: Grant): GrantDto => ({
  customerId: Number.parseInt(grant.customerId.toString()),
  resourceType: grant.resourceType,
  roleId: grant.roleId.toString(),
  resourceId: grant.resourceId.toString(),
});
